<!-- 
    * 射门分布及期望进球
 -->

<template>
  <div
    class="shootingDistribution_expectedGoal_scatter"
    :class="isAutoExportPng ? 'autoExportPng' : ''"
  >
    <div class="horizontal_box">
      <div :class="isBorder ? 'echartsBorder' : ''" class="echartsBg">
        <div
          id="chartDom"
          ref="chartDom"
          :style="{ height: chartDomHPx }"
          @click.stop="downLoad($refs.chartDom, true)"
        ></div>
      </div>
      <div class="tip_box" v-if="isTipFlag">
        <span class="bottom_tipArea">
          <span class="bottom_tipArea_left">
            <span class="pointType">
              <i class="goal"></i>
              <span v-text="'进球'"></span>
            </span>
            <span class="pointType">
              <i class="unGoal"></i>
              <span v-text="'射失'"></span>
            </span>
          </span>
          <span class="bottom_tipArea_right">
            <span class="pointSizes">
              <i
                v-for="(item, index) in symbolSizeArr"
                :key="index"
                :style="{
                  width: `${Math.ceil(item)}px`,
                  height: `${Math.ceil(item)}px`,
                }"
              ></i>
            </span>
            <span class="pointText" v-text="'期望进球'"></span>
          </span>
        </span>
        <span class="left_tipArea" v-if="tipLRList && tipLRList[0]">
          <span
            class="tipArea_row"
            v-for="(item, index) in tipLRList[0]"
            :key="index"
          >
            <span class="tipArea_row_title" v-text="item.title"></span>
            <span
              class="tipArea_row_val"
              v-text="_valFormatHandler(item.val)"
            ></span>
          </span>
        </span>
        <span class="right_tipArea" v-if="tipLRList && tipLRList[1]">
          <span
            class="tipArea_row"
            v-for="(item, index) in tipLRList[1]"
            :key="index"
          >
            <span class="tipArea_row_title" v-text="item.title"></span>
            <span
              class="tipArea_row_val"
              v-text="_valFormatHandler(item.val)"
            ></span>
          </span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
// 射门分布及期望进球
import cup_base_data_mixin from '@mixins/cup_base_data'
import canvasToImage_base64_data_mixin from '@mixins/canvasToImage_base64_data'
export default {
  name: 'coordinateSystemScatter',
  mixins: [canvasToImage_base64_data_mixin, cup_base_data_mixin],
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
    isBorder: {
      //演播室要球场和边界区域一起的，所以不要边，比例是2000/1340=1.49，约等于1.5
      type: Boolean,
      default: false,
    },
    isAutoExportPng: {
      //是否导出图片页面使用
      type: Boolean,
      default: false,
    },
    isTipFlag: {
      //是否显示提示信息
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      homeBgColor: 'rgba(230, 52, 84, 1)', //主队：【覆盖色】
      awayBgColor: 'rgba(101, 199, 199, 1)', //客队：【覆盖色】
      expectedGoal_defaultColor: 'rgba(233, 233, 210, 1)', // 期望进球颜色
      initFlag: false,
      myChart: null,
      chartDomHPx: 'auto',
      symbolSizeArr: null,
      tipLRList: null,
    }
  },
  created() {
    if (this.currThemeObj && this.currThemeObj.cssStyle) {
      const cssStyle = this.currThemeObj.cssStyle
      // console.debug("cssStyle:", cssStyle)
      this.homeBgColor = cssStyle.echarts_shootDis_ExpetGoal_homeColor
      this.awayBgColor = cssStyle.echarts_shootDis_ExpetGoal_awayColor
      this.expectedGoal_defaultColor =
        cssStyle.echarts_shootDis_expectedGoal_defaultColor
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initEchartFlag()
    })
  },
  beforeDestroy() {
    //性能优化，防止溢出
    if (this.myChart) {
      this.myChart.dispose() //销毁echarts实例，防止内侧泄露
    }
  },
  components: {},
  watch: {
    datas(val) {
      if (this.initFlag && this.myChart) {
        this.initdata(val.data.dataList)
        this.initEcharts()
      }
    },
  },
  methods: {
    initEchartFlag() {
      setTimeout(() => {
        if (this.$refs.chartDom && this.$refs.chartDom.clientWidth) {
          this.chartDomHPx = `${Math.ceil(
            this.$refs.chartDom.clientWidth / 1.5
          )}px`
          this.symbolSize = Math.floor(this.$refs.chartDom.clientWidth * 0.02)
          const symbolSizeRArr = [0.01, 0.333, 0.666, 1]
          const symbolSizeArr = symbolSizeRArr.map((val) => {
            return this.symbolSize + Math.round(val * 10 * 100) / 100
          })
          this.symbolSizeArr = symbolSizeArr
          const legendData = this.datas.data.legendData
            ? this.datas.data.legendData[0]
            : {}
          console.debug('this.symbolSize:', this.symbolSize)
          const tipArr = [
            {
              key: 'Shot',
              name: '射门:',
            },
            {
              key: 'Goal',
              name: '进球:',
            },
            {
              key: 'SumExpectedGoals',
              name: '期望进球:',
            },
            {
              key: 'ShotDistance',
              name: '平均射门距离:',
            },
          ]
          const homeAwayArr = ['home', 'away']
          const tipLRList = homeAwayArr.map((key) => {
            return tipArr.map((val) => {
              let ceil = ''
              if (val.key == 'ShotDistance') {
                ceil = '米'
              }
              return {
                title: val.name,
                val:
                  this._valFormatHandler(legendData[`${key}${val.key}`]) +
                  (ceil ? ceil : ''),
              }
            })
          })
          this.tipLRList = tipLRList

          this.$nextTick(() => {
            this.initdata(this.datas.data.dataList)
            // this.initdata(dataList) //测试数据入口
            this.initFlag = true
            this.initEcharts()
            // this.myChart.on('click', 'series.line', (params) => {
            //   console.debug(params)
            //   if (params.componentType == 'markPoint') {
            //     // 点击了 markPoint
            //     this.isMarkFlag = true
            //   }
            // })
          })
        } else {
          this.initEchartFlag()
        }
      }, 50)
    },
    initdata(dataList) {
      // dataList = [[{ averageX: 59, averageY: 51, shirtNumber: 9 }]]
      const allPlayerData = []
      // 播出单里面导出图片所占的width:310左右
      const ratio = (this.$refs.chartDom.clientWidth / 310).toFixed(2) - 0
      dataList.forEach((item, index) => {
        let homeAway = ''

        item.forEach((point) => {
          let x = 0,
            y = 0,
            symbolSize = this.symbolSize,
            pointColor = this.expectedGoal_defaultColor
          if (point.shotTarget == 1) {
            pointColor = this.homeBgColor
          } else if (point.shotTarget == 2) {
            pointColor = this.awayBgColor
          } else {
          }
          if (!point.expectedGoals) {
            pointColor = this.expectedGoal_defaultColor
          }

          if (index == 0) {
            homeAway = 'HOME'
            x = point.X
            y = point.Y
          }
          if (index == 1) {
            homeAway = 'AWAY'
            x = 100 - point.X
            y = 100 - point.Y
          }
          symbolSize +=
            Math.round(
              (point.expectedGoals ? point.expectedGoals : 0) *
                10 *
                1.2 *
                ratio *
                100
            ) / 100
          allPlayerData.push({
            name: `${homeAway}_${
              point.expectedGoals ? point.expectedGoals : point.shotDistance
            }`,
            value: [x, y, point.expectedGoals],
            symbol: 'circle',
            symbolSize,
            itemStyle: {
              color: pointColor,
              opacity: 1,
            },
          })
        })
        this.allPlayerData = allPlayerData
      })
    },
    clickEchartBox(e) {
      console.debug(e)
      if (!this.isMarkFlag) {
        // 清空关键事件
        console.debug('清空关键事件')
      }
      this.isMarkFlag = false
    },
    initEcharts() {
      // 2000/1340
      const dom = this.$refs.chartDom

      let option = {
        title: {
          show: false,
          text: '射门分布及期望进球',
        },
        animation: !this.isAutoExportPng,
        tooltip: {
          show: false,
          trigger: 'axis',
        },
        grid: {
          top: `0`,
          bottm: `0`,
          left: '1.4%',
          right: '1.4%',
          width: '97.2%',
          height: `100%`,
        },
        // dataZoom: {
        //   show: true,
        //   type: 'inside',
        //   zoomLock: true,
        // },
        legend: {
          show: false,
        },
        xAxis: {
          // type: 'category',
          boundaryGap: false,
          max: 100,
          axisLine: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            show: false,
          },
        },
        yAxis: {
          boundaryGap: false,
          max: 100,
          axisLabel: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        series: [
          {
            data: this.allPlayerData,
            type: 'scatter',
          },
        ],
      }
      this.myChart = this.$echarts.init(this.$refs.chartDom)
      this.myChart.setOption(option)

      if (this.isAutoExportPng) {
        setTimeout(() => {
          this.upLoad(
            this.$refs.chartDom,
            true,
            'uploadData',
            this.datas.data.legendData
          )
        }, 5 * 1000)
      }
    },
    _valFormatHandler(val, ceil) {
      let data
      // console.debug(val, typeof val)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = ' -'
      } else {
        if (val && ceil) {
          data = `${val}${ceil ? ceil : ''}`
        } else {
          data = val
        }
      }
      // console.debug(val, data)
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.shootingDistribution_expectedGoal_scatter {
  position: relative;
  width: 59%;
  &.autoExportPng {
    width: 100%;
    .horizontal_box {
      border: 0;
      background: transparent;
      border-radius: 0;
    }
  }
  .horizontal_box {
    border: 0.416vw solid var(--mixtmt_echarts_footBallPlaygroundColor);
    background: var(--mixtmt_echarts_footBallPlaygroundColor);
    border-radius: 0.694vw;
  }
  .echartsBg {
    background-color: var(--mixtmt_echarts_footBallPlaygroundBgColor);
  }
  .tip_box {
    color: var(--mixtmt_blackColor);
    .bottom_tipArea {
      position: absolute;
      bottom: -2.22vw;
      left: 0;
      z-index: 10;
      width: 100%;
      height: 2.083vw;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      background-color: var(--mixtmt_echarts_footBallPlaygroundColor);
      border-radius: 0.325vw;
      .bottom_tipArea_left,
      .bottom_tipArea_right {
        width: 50%;
        display: flex;
        display: -webkit-flex;
        align-items: center;
      }
      .bottom_tipArea_left {
        justify-content: space-evenly;
        .pointType {
          width: 100%;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          i {
            width: 1.11vw;
            height: 1.11vw;
            border-radius: 50%;
            /* background-color: red; */
          }
          span {
            padding-left: 0.222vw;
            font-size: 0.833vw;
            font-weight: bold;
          }
          .goal {
            background-color: var(
              --mixtmt_echarts_shootDis_ExpetGoal_homeColor
            );
          }
          .unGoal {
            background-color: var(
              --mixtmt_echarts_shootDis_ExpetGoal_awayColor
            );
          }
          /* .ownGoal {
            background-color: var(
              --mixtmt_echarts_shootDis_ExpetGoal_ownGoalColor
            );
          } */
        }
      }
      .bottom_tipArea_right {
        justify-content: center;
        .pointSizes {
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          i {
            margin: 0 0.222vw;
            /* width: 1vw; */
            /* height: 1vw; */
            border-radius: 50%;
            background-color: var(
              --mixtmt_echarts_shootDis_expectedGoal_defaultColor
            );
          }
        }
        .pointText {
          padding-left: 0.222vw;
          font-size: 0.833vw;
          font-weight: bold;
        }
      }
    }
    .left_tipArea,
    .right_tipArea {
      position: absolute;
      top: 50%;
      z-index: 10;
      width: calc(30% - 0.444vw);
      height: auto;
      transform: translateY(-50%);
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      padding: 0.222vw 0;
      background-color: var(--mixtmt_echarts_footBallPlaygroundColor);
      border-radius: 0.325vw;

      .tipArea_row {
        width: 100%;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding-bottom: 0.5vw;
        .tipArea_row_title,
        .tipArea_row_val {
          width: 100%;
          padding: 0 0.3vw;
          font-size: 0.833vw;
          line-height: 1.28vw;
          text-align: left;
        }
        .tipArea_row_title {
          font-weight: bold;
        }
      }
    }
    .left_tipArea {
      left: -30%;
      span {
        text-align: left;
      }
    }
    .right_tipArea {
      right: -30%;
      span {
        text-align: right;
      }
    }
  }
}
.echartsBorder {
  border: 0.416vw solid #eaedf1;
  background: #eaedf1;
  border-radius: 0.694vw;
}
#chartDom {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  background-image: var(--mixtmt_ball_bg);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  font-size: 0;
  // border:6px solid #EAEDF1;
  // border-radius: 14px;
  // box-sizing: content-box;
}
#chartDom {
  width: 100%;
  height: 100%;
  transform: rotateX(0deg);
}
</style>
